import { useTranslations } from 'next-intl';
import { type tabKeyType } from '@/app/[locale]/(landing)/components/latest-activity/data';

export const useActivityColumns = (selectedTab: tabKeyType) => {
  const t = useTranslations('landing.latest-activity');

  const columns = {
    CASINO_BETS: [
      {
        accessorKey: 'user',
        header: () => t('column.user'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'game',
        header: () => t('column.game'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'betAmount',
        header: () => t('column.bet-amount'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'multiplier',
        header: () => t('column.multiplier'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'payout',
        header: () => t('column.payout'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
    ],
    SPORTS_BETS: [
      {
        accessorKey: 'user',
        header: () => t('column.user'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'sport',
        header: () => t('column.sport'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'event',
        header: () => t('column.event'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'betAmount',
        header: () => t('column.bet-amount'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
      {
        accessorKey: 'payout',
        header: () => t('column.payout'),
        cell: (info: any) => <span className="truncate">{info.getValue()}</span>,
      },
    ],
  };

  return columns[selectedTab];
};
